import { render, staticRenderFns } from "./FakeModal.vue?vue&type=template&id=27b320be&"
import script from "./FakeModal.vue?vue&type=script&lang=js&"
export * from "./FakeModal.vue?vue&type=script&lang=js&"
import style0 from "./FakeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports